AFRAME.registerComponent('rotation-controls', {
  schema: {
    target: { type: 'selector' },
    cameraRig: { type: 'selector', default: '#cameraRig' }
  },

  init: function () {
    const el = this.el;
    const component = this;
    const cameraRig = this.data.cameraRig || document.querySelector('#cameraRig');

    const getCurrentTarget = () => {
      let target = component.data.target;
      if (target && target.isConnected && document.body.contains(target)) {
        return target;
      }
      if (target && target.id) {
        target = document.getElementById(target.id);
        if (target && target.isConnected) {
          return target;
        }
      }
      target = document.querySelector('#stock-3d-cube-wrapper');
      if (target && target.isConnected) {
        return target;
      }
      const allWrappers = document.querySelectorAll('[id$="-wrapper"]');
      for (let wrapper of allWrappers) {
        if (wrapper.isConnected && wrapper.id.includes('stock-3d-cube')) {
          return wrapper;
        }
      }

      return null;
    };

    if (!cameraRig) {
      console.warn("[rotation-controls] No camera rig found. Billboard updates may not work.");
    } else {
      console.log("[rotation-controls] Camera rig found:", cameraRig);
    }


    const title = document.createElement('a-troika-text');
    title.setAttribute('value', 'Chart rotation');
    title.classList.add('rotation-text');
    title.setAttribute('font-size', 0.045);
    title.setAttribute('anchor', 'center');
    title.setAttribute('position', `0 0.25 0.05`)
    const color = document.querySelector('body').classList.contains('light') ? '#111' : '#aaa';
    title.setAttribute('color', color)
    el.appendChild(title);

    const parsedSettings = getCacheItem('configureControlSettings');
    if (parsedSettings && parsedSettings.themeMode) {
        title.setAttribute('color', parsedSettings.themeMode === 'Dark' ? '#AAA' : '#111')
    }


    const buttons = [
      { id: "rotate-x-1", image: "./vr-assets/rotation-icons-2/up.png", position: "0 0.15 0.001", axis: "x", delta: -10 },
      { id: "rotate-x-2", image: "./vr-assets/rotation-icons-2/down.png", position: "0 0 0.001", axis: "x", delta: 10 },
      { id: "rotate-z-1", image: "../vr-assets/rotation-icons-2/top-left.png", position: "-0.15 0.15 0.001", axis: "z", delta: -10 },
      { id: "rotate-z-2", image: "./vr-assets/rotation-icons-2/top-right.png", position: "0.15 0.15 0.001", axis: "z", delta: 10 },
      { id: "rotate-y-1", image: "./vr-assets/rotation-icons-2/left.png", position: "-0.15 0 0.001", axis: "y", delta: -10 },
      { id: "rotate-y-2", image: "./vr-assets/rotation-icons-2/right.png", position: "0.15 0 0.001", axis: "y", delta: 10 },

      { id: "reset", text: "Reset", position: "0.524 0.15 0.001", axis: "reset" }
    ];

    buttons.forEach(({ id, label, image, text, position, axis, delta }) => {
      const btn = document.createElement("a-entity");
      btn.setAttribute("id", id);
      btn.setAttribute("ui-button", {
        label: text || "",
        image: image || '',
        width:  id === 'reset' ? 0.42 : 0.12,
        height: 0.12,
        depth: 0.02,
        type: "rounded-box",
        colorScheme: "primary",
        radius: 0.015,
        preferredFontSize: 0.04,
        textZp: 0.015,
        // isAutoRotationContent: !text
      });
      // btn.setAttribute("rotation", "0 0 -45");
      btn.setAttribute("position", position);

      btn.addEventListener("click", () => {
        const target = getCurrentTarget();

        if (!target) {
          console.warn(`[rotation-controls ${id}] Button clicked, but no target available.`);
          return;
        }

        const rot = target.getAttribute("rotation") || { x: 0, y: 0, z: 0 };

        if (axis === "reset") {
          let resetRotation = "30 45 0";
          
          const typeControl = document.querySelector('[chart-type-control]');
          const action = typeControl?.getAttribute('chart-type-control')?.selectedPrimeAction;
          
          if (action === 'mmap') {
            const mmapMode = (typeof getCacheItem === 'function' ? getCacheItem('mmap_view_mode') : null) || '2d';
            resetRotation = mmapMode === '3d' ? "30 45 0" : "90 45 0";
          }
          
          target.setAttribute("rotation", resetRotation);
          const rotationValues = { 
            x: parseFloat(resetRotation.split(' ')[0]), 
            y: parseFloat(resetRotation.split(' ')[1]), 
            z: parseFloat(resetRotation.split(' ')[2]) 
          };
          target.emit('update-rotation', rotationValues);
          component.el.sceneEl.emit('update-rotation', rotationValues);
        } else {
          let newRot;
          if (axis === "x") {
            const radY = (rot.y || 0) * Math.PI / 180;
            const adjustedDelta = delta * Math.cos(radY);
            newRot = { ...rot, x: (rot.x + adjustedDelta + 360) % 360 };
          } else {
            newRot = { ...rot, [axis]: (rot[axis] + delta + 360) % 360 };
          }
          
          target.setAttribute("rotation", `${newRot.x} ${newRot.y} ${newRot.z}`);
          target.emit('update-rotation', newRot);
          component.el.sceneEl.emit('update-rotation', newRot);
        }
        if (cameraRig) {
          if (window.AppState.isTrueVRMode) {
            cameraRig.emit('update-billboards');
          } else {
            cameraRig.emit('refresh-billboards');
          }
        }

        if (window.gtag) gtag('event', `VR_CenterPanel_ChartRotation`);
      });

      el.appendChild(btn);
    });
  },

  update: function (oldData) {
    if (oldData.target !== this.data.target) {
      console.log("[rotation-controls] Target updated:", this.data.target);
    }
  }
});
